import { Button, CircularProgress, Typography } from '@/ui';

import type { FC } from 'react';

export const PageLoading: FC = () => (
  <div className="flex justify-center py-16">
    <CircularProgress aria-label="Loading" />
  </div>
);

// NEW COPY: "Couldn’t load this page." / "Try again".
export const LoadError: FC<{ onRetry: () => void }> = ({ onRetry }) => (
  <div className="flex flex-col items-start gap-3 py-8">
    <Typography variant="body1">Couldn’t load this page.</Typography>
    <Button size="small" variant="outlined" onClick={onRetry}>
      Try again
    </Button>
  </div>
);
